import React from "react";
import { IoMdArrowDropright } from "react-icons/io";
import { FaSquare, FaCheckSquare, FaMinusSquare } from "react-icons/fa";
import cx from "classnames";
import { ArrowIconProps, CheckBoxIconProps } from "../../../../Types/BonusUi.type";

// Universal wrapper to make react-icons v5 compatible with TS JSX rules
const IconWrapper = (Icon: any, props: any = {}) =>
    React.createElement(Icon as React.ComponentType<any>, props);

export function ArrowIcon({ isOpen, className }: ArrowIconProps) {
    const baseClass = "arrow";
    const classes = cx(
        baseClass,
        { [`${baseClass}--closed`]: !isOpen },
        { [`${baseClass}--open`]: isOpen },
        className
    );

    return IconWrapper(IoMdArrowDropright, { className: classes });
}

export function CheckBoxIcon({ variant, onClick, ...rest }: CheckBoxIconProps) {
    switch (variant) {
        case "all":
            return (
                <span onClick={onClick}>
                    {IconWrapper(FaCheckSquare, rest)}
                </span>
            );

        case "none":
            return (
                <span onClick={onClick}>
                    {IconWrapper(FaSquare, rest)}
                </span>
            );

        case "some":
            return (
                <span onClick={onClick}>
                    {IconWrapper(FaMinusSquare, rest)}
                </span>
            );

        default:
            return null;
    }
}





// import { IoMdArrowDropright } from "react-icons/io";
// import { FaSquare, FaCheckSquare, FaMinusSquare } from "react-icons/fa";
// import cx from "classnames";
// import { ArrowIconProps, CheckBoxIconProps } from "../../../../Types/BonusUi.type";

// export function ArrowIcon ({ isOpen, className }: ArrowIconProps) {
//     const baseClass = "arrow";
//     const classes = cx(
//         baseClass,
//         { [`${baseClass}--closed`]: !isOpen },
//         { [`${baseClass}--open`]: isOpen },
//         className
//     );
//     return <IoMdArrowDropright className={classes} />;
// };

// export function CheckBoxIcon ({ variant, onClick, ...rest }: CheckBoxIconProps) {
//     switch (variant) {
//         case "all":
//             return (
//                 <span onClick={onClick}>
//                     <FaCheckSquare {...rest} />
//                 </span>);
//         case "none":
//             return (
//                 <span onClick={onClick}>
//                     <FaSquare {...rest} />
//                 </span>);
//         case "some":
//             return (
//                 <span onClick={onClick}>
//                     <FaMinusSquare {...rest} />
//                 </span>);
//         default:
//             return null;
//     }
// };